import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { createRequestOption } from '../helpers/request-util';

@Injectable({
  providedIn: 'root'
})
export class ListaBlancaService {

  public resourceUrl = environment.apiUrl + 'camera/lista_blanca';
  constructor(public http: HttpClient) { }

  create(vehiculo: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl, vehiculo);
  }

  update(vehiculo: any): Observable<any> {
    return this.http.put<any>(this.resourceUrl, vehiculo);
  }

  find(id: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/${id}`);
  }

  query(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceUrl, { params: options });
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`);
  }
}
